import "./emptyState.scss";

import PropTypes from "prop-types";
import React from "react";

import { MINDMAP_VIEW, NARRATIVE_VIEW, SUBWAY_VIEW, TIMELINE_VIEW } from "../../constants/identifiers";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import { withContainerContext } from "../container/ContainerContext";

const childrenToObject = children => {
  let backup = {};
  if (children && children.length) {
    backup = children.reduce((obj, child) => {
      obj[child.key] = child;
      return obj;
    }, {});
  } else if (children) {
    backup[children.key] = children;
  }
  return backup;
};

const EmptyState = props => {
  const children = childrenToObject(props.children);
  const style = {
    maxWidth: `${props.containerRect.width}px`,
    maxHeight: `${props.containerRect.height}px`,
    position: props.absolute ? "absolute" : props.fixed ? "fixed" : "static",
    marginTop:
      props.type === "text"
        ? `${(props.containerRect.height - 50) / 2}px`
        : props.type === "sidePanel" && !preprocessorQuery.isMobile()
          ? "20px"
          : "0"
  };
  const svgWrapperClass = props.absolute
    ? `empty-state-svg-wrapper-absolute`
    : props.fixed
      ? `empty-state-svg-wrapper-fixed`
      : `empty-state-svg-wrapper`;

  if (props.type === "text" || props.type === "sidePanel") {
    let onboardingSvg = props.svg ? (
      <div className={svgWrapperClass}>
        <svg className={`empty-state-svg-${props.type}`}>
          <use xlinkHref={`#${props.svg}EmptyState`} />
        </svg>
      </div>
    ) : null;

    return (
      <div className={`empty-state empty-state-${props.type}`} style={style}>
        {onboardingSvg}
        {children.content ? <div className="empty-state-content">{children.content}</div> : null}
      </div>
    );
  }

  const pointerIcon = (
    <svg className={`empty-state-svg-icon empty-state-svg-icon-pointer`}>
      <use xlinkHref={`#pointerEmptyState`} />
    </svg>
  );
  const sidebarAddIcon = (
    <svg className={`empty-state-svg-icon empty-state-svg-icon-add`}>
      <use xlinkHref={`#sidebarAdd`} />
    </svg>
  );

  if (props.type === "view") {
    if (props.view === TIMELINE_VIEW) {
      let message;
      //#!if desktop === true
      if (!props.isFiltered) {
        message = <span>Double click to add to your timeline</span>;
      } else {
        message = <span>Double click to add to your filtered timeline</span>;
      }
      //#!elseif tablet === true
// if (!props.isFiltered) {
// message = <span>Tap {sidebarAddIcon} in the sidebar to add to your timeline</span>;
// } else {
// message = <span>Tap {sidebarAddIcon} in the sidebar to add to your filtered timeline</span>;
// }
      //#!else
// if (!props.isFiltered) {
// message = <span>Tap {sidebarAddIcon} to add to your timeline</span>;
// } else {
// message = <span>Tap {sidebarAddIcon} to add to your filtered timeline</span>;
// }
      //#!endif

      return (
        <div className="empty-state empty-state-timeline" style={style}>
          {/*#!if desktop === true */}
          <div className="empty-state-icon">{pointerIcon}</div>
          {/*#!endif */}
          <div className="empty-state-message">{message}</div>
        </div>
      );
    } else if (props.view === SUBWAY_VIEW) {
      const message = `No tracks shown. Add a track to get started.`;

      return (
        <div className="empty-state empty-state-subway" style={style}>
          <div className={svgWrapperClass}>
            <svg className={`empty-state-svg-subway`}>
              <use xlinkHref={`#subwayEmptyState`} />
            </svg>
            <div className="empty-state-message">{message}</div>
          </div>
        </div>
      );
    } else if (props.view === NARRATIVE_VIEW) {
      let message;
      if (!props.isFiltered) {
        message = `Your narrative is empty. Add a folder to get started.`;
      } else {
        message = `Your filtered narrative is empty. Add a folder to get started.`;
      }

      return (
        <div className="empty-state empty-state-narrative" style={style}>
          <div className={svgWrapperClass}>
            {/* #!if iOS !== true */}
            <svg className={`empty-state-svg-narrative`}>
              <use xlinkHref={`#narrativeEmptyState`} />
            </svg>
            {/* #!endif */}
            <div className="empty-state-message">{message}</div>
          </div>
        </div>
      );
    } else if (props.view === MINDMAP_VIEW) {
      let message;
      let connectorsMessage;
      //#!if desktop === true
      message = <span>{pointerIcon} Double click to add to your mindmap</span>;
      connectorsMessage = `Drag connectors to add relationships`;
      //#!else
// message = <span>Tap {sidebarAddIcon} in the sidebar to add to your mindmap</span>;
// connectorsMessage = `Long press to enter edit mode to add relationships`;
      //#!endif

      return (
        <div className="empty-state empty-state-mindmap" style={style}>
          <div className="empty-state-message">{message}</div>
          {connectorsMessage ? (
            <div className="empty-state-connectors">
              <svg className={`empty-state-svg-connectors`}>
                <use xlinkHref={`#connectorsEmptyState`} />
              </svg>
              {connectorsMessage}
            </div>
          ) : null}
        </div>
      );
    }
  }

  return null;
};

EmptyState.propTypes = {
  view: PropTypes.string,
  type: PropTypes.oneOf(["text", "sidePanel", "view"]).isRequired,
  svg: PropTypes.string,
  absolute: PropTypes.bool,
  fixed: PropTypes.bool,
  children: PropTypeShapes.elementOrArray,
  isFiltered: PropTypes.bool,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default React.memo(withContainerContext(EmptyState));
